module.exports = __webpack_public_path__ + "img/no_data_server.53f6c51f.jpg";